import { graphql } from "@/graphql/generated/gql";

export const workspaceMembershipListForWorkspaceQueryDocument = graphql(/* GraphQL */ `
  query workspaceMembershipListForWorkspace($input: String!) {
    workspaceMembershipListForWorkspace(workspaceId: $input) {
      ...WorkspaceMembershipListFields
    }
  }
`);

export const regenerateWorkspaceMembershipInviteTokenMutationDocument = graphql(/* GraphQL */ `
  mutation regenerateWorkspaceMembershipInviteToken($userId: String!, $workspaceId: String!) {
    regenerateWorkspaceInviteToken(userId: $userId, workspaceId: $workspaceId)
  }
`);

export const findWorkspaceInviteQueryDocument = graphql(/* GraphQL */ `
  query findWorkspaceInvite($input: String!) {
    findWorkspaceInvite(token: $input) {
      id
      userId
      workspaceId
      user {
        id
        email
        username
        fullname
        profilePicture
        activated
        hasSetPassword
      }
      workspace {
        id
        name
        workspaceUrl
        logo
      }
      federatedLogin {
        startUrl
      }
    }
  }
`);

export const updateWorkspaceMembershipRoleMutationDocument = graphql(/* GraphQL */ `
  mutation updateWorkspaceMembershipRole($input: WorkspaceMembershipUpdateRoleInput!) {
    updateWorkspaceMembershipRole(workspaceMembershipUpdateRoleInput: $input) {
      ...WorkspaceMembershipListFields
    }
  }
`);

export const updateWorkspaceMembershipStatusMutationDocument = graphql(/* GraphQL */ `
  mutation updateWorkspaceMembershipStatus($input: WorkspaceMembershipUpdateStatusInput!) {
    updateWorkspaceMembershipStatus(workspaceMembershipUpdateStatusInput: $input) {
      ...WorkspaceMembershipListFields
    }
  }
`);

export const leaveWorkspaceMembershipMutationDocument = graphql(/* GraphQL */ `
  mutation leaveWorkspaceMembership($input: WorkspaceMembershipLeaveInput!) {
    leaveWorkspaceMembership(workspaceMembershipLeaveInput: $input) {
      ...WorkspaceMembershipListFields
    }
  }
`);

export const rejoinWorkspaceMembershipMutationDocument = graphql(/* GraphQL */ `
  mutation rejoinWorkspaceMembership($input: WorkspaceMembershipRejoinInput!) {
    rejoinWorkspaceMembership(workspaceMembershipRejoinInput: $input) {
      id
      userId
      workspaceId
      role
      status
      updatedAt
      createdAt
    }
  }
`);

export const createWorkspaceInviteMutationDocument = graphql(/* GraphQL */ `
  mutation createWorkspaceInvite($input: WorkspaceInviteCreateWithEmailInput!) {
    createWorkspaceInvite(workspaceInviteCreateWithEmailInput: $input) {
      id
      userId
      workspaceId
      role
      status
      accountType
      updatedAt
      createdAt
      user {
        id
        email
      }
    }
  }
`);

export const updateWorkspaceMembershipAccountTypeMutationDocument = graphql(/* GraphQL */ `
  mutation updateWorkspaceMembershipAccountType($input: WorkspaceMembershipUpdateAccountTypeInput!) {
    updateWorkspaceMembershipAccountType(workspaceMembershipUpdateAccountTypeInput: $input) {
      ...WorkspaceMembershipListFields
    }
  }
`);

export const acceptWorkspaceInviteMutationDocument = graphql(/* GraphQL */ `
  mutation acceptWorkspaceInvite($input: WorkspaceInviteAcceptInput!) {
    acceptWorkspaceInvite(workspaceInviteAcceptInput: $input) {
      userId
      workspaceId
      status
      user {
        id
        email
        username
        fullname
        profilePicture
        activated
      }
      workspace {
        id
        name
        workspaceUrl
        logo
      }
    }
  }
`);

export const deleteWorkspaceInviteMutationDocument = graphql(/* GraphQL */ `
  mutation deleteWorkspaceInvite($input: WorkspaceInviteDeleteInput!) {
    deleteWorkspaceInvitation(workspaceInviteDeleteInput: $input) {
      userId
      workspaceId
    }
  }
`);

export const resendWorkspaceInviteNotificationMutationDocument = graphql(/* GraphQL */ `
  mutation resendWorkspaceInviteNotification($input: WorkspaceInviteUpdateInput!) {
    resendWorkspaceInviteNotification(workspaceInviteUpdateInput: $input) {
      userId
      workspaceId
    }
  }
`);

export const removeWorkspaceMembershipMutationDocument = graphql(/* GraphQL */ `
  mutation removeWorkspaceMembership($input: WorkspaceMembershipDeleteInput!) {
    removeWorkspaceMembership(workspaceMembershipDeleteInput: $input) {
      userId
      workspaceId
    }
  }
`);
